import {
  SkeletonBody,
  SkeletonText,
  SkeletonBone,
  SkeletonButton,
  SkeletonProfilePic,
} from '@collegebacker/backer-ui/ui'
import styles from './GiftingSkeleton.module.scss'

export const GiftingSkeleton: React.FC = () => {
  return (
    <SkeletonBody className={styles.container} showBackground={false}>
      <div className={styles.headerContainer}>
        <div className={styles.header}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <SkeletonBone
                style={{
                  marginRight: '15px',
                }}
                className={`${styles.header_navElement} ${styles.header_navElementIcon}`}
              />
            </div>

            <SkeletonBone
              className={`${styles.header_navElement} ${styles.header_navElementText}`}
            />
          </div>
        </div>
      </div>

      <div className={styles.content}>
        <SkeletonBody className={styles.content_left} showBackground={false}>
          <div className={styles.content_stat}>
            <SkeletonBone className={styles.polaroidPhoto} />
            <SkeletonText lines={1} fontSize="title-large" />

            <div
              style={{
                display: 'flex',
              }}
            >
              <SkeletonText
                lines={1}
                fontSize="title-large"
                style={{
                  width: '80px',
                  marginRight: '15px',
                }}
              />
              <SkeletonButton
                size="small"
                style={{
                  width: '120px',
                }}
              />
            </div>
          </div>

          <div className={styles.content_about}>
            <SkeletonText lines={3} fontSize="body-main" />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <SkeletonProfilePic
                style={
                  {
                    marginRight: '15px',
                    '--size': '50px',
                  } as any
                }
              />
              <SkeletonText
                lines={1}
                fontSize="body-main"
                style={{
                  width: '100px',
                }}
              />
            </div>

            <SkeletonButton
              size="default"
              className={`${styles.hideOnDesktop}`}
            />
          </div>
        </SkeletonBody>

        <SkeletonBody className={styles.content_right}>
          <div className={styles.content_right_top}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <SkeletonText
                lines={1}
                fontSize="title-medium"
                style={{
                  width: '180px',
                }}
              />
              <SkeletonText
                lines={1}
                fontSize="body-main"
                style={{
                  width: '220px',
                }}
              />
            </div>

            <SkeletonText
              lines={1}
              fontSize="title-medium"
              className={`${styles.content_right_top_logo} ${styles.hideOnMobile}`}
            />
          </div>

          <div className={styles.content_right_sliderWrap}>
            <SkeletonBone
              style={{
                height: '120px',
                width: '100%',
                marginBottom: '15px',
              }}
            />
            <SkeletonText
              lines={1}
              fontSize="body-main"
              style={{
                width: '200px',
              }}
            />
          </div>

          <div className={styles.content_right_paymentTweeks}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <SkeletonText
                lines={1}
                fontSize="body-main"
                style={{
                  width: '100px',
                  marginRight: '15px',
                }}
              />
              <SkeletonButton
                size="small"
                style={{
                  width: '120px',
                }}
              />
            </div>

            <SkeletonButton
              size="small"
              style={{
                width: '120px',
              }}
            />
          </div>

          <div className={styles.content_right_buttons}>
            <SkeletonButton
              size="default"
              style={{
                flex: 1,
              }}
            />
            <SkeletonButton
              size="default"
              style={{
                flex: 1,
              }}
              className={`${styles.hideOnMobile}`}
            />
          </div>
        </SkeletonBody>
      </div>
    </SkeletonBody>
  )
}
